import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './styles.css'
import './workflows.css'
import './products.css'
import './sales.css'
import './pricing.css'
import './commerce.css'
import './email.css'
import './mobile-fixes.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
